import { render } from "./AttrTabPanel.vue?vue&type=template&id=4cf37417"
import script from "./AttrTabPanel.vue?vue&type=script&lang=js"
export * from "./AttrTabPanel.vue?vue&type=script&lang=js"

import "./AttrTabPanel.vue?vue&type=style&index=0&id=4cf37417&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/widgets/components_core/AttrTabPanel.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4cf37417"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4cf37417', __exports__)) {
    api.reload('4cf37417', __exports__)
  }
  
  module.hot.accept("./AttrTabPanel.vue?vue&type=template&id=4cf37417", () => {
    api.rerender('4cf37417', render)
  })

}


export default __exports__